export const consoleLog = (...log: unknown[]) => {
    if (console?.log) {
        console.log(...log)
    }
}
